import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Accordion from '~/components/ui/Accordion/Accordion';
import VCardContactInfo from '~/components/VCardPlusQRContent/VCardPlusBasicInformation/VCardContactInfo';
import VCardPlusAboutYou from '~/components/VCardPlusQRContent/VCardPlusBasicInformation/VCardPlusAboutYou/VCardPlusAboutYou';
import VCardPlusLocation from '~/components/VCardPlusQRContent/VCardPlusBasicInformation/VCardPlusLocation';
import VCardPlusSummary from '~/components/VCardPlusQRContent/VCardPlusBasicInformation/VCardPlusSummary';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import {
  updateVCardEmailThunk,
  updateVCardPhoneThunk,
  updateVCardPlusLocationThunk,
  updateVCardPlusPersonThunk,
  updateVCardPlusSiteThunk,
  updateVCardWebsiteThunk,
} from '~/store/reducers/previewScreens/vcard-plus';
import { getVCardPlusReducer } from '~/store/reducers/previewScreens/vcard-plus/selectors';

export default function BasicInformation() {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const vCardPlusState = useSelector(getVCardPlusReducer);

  const {
    micrositeData,
    selectedTemplate,
    basicInformation: { summary },
  } = vCardPlusState;

  const updateVCardPlusData = (body) => {
    dispatch(
      updateVCardPlusSiteThunk({
        id: micrositeData.id,
        body,
      }),
    );
  };

  const updateVCardPlusLocation = ({ locationId, body }) => {
    dispatch(
      updateVCardPlusLocationThunk({
        id: locationId,
        body,
      }),
    );
  };

  const createVCardPlusEmail = (data) => {
    dispatch(
      updateVCardEmailThunk({
        id: data.microsite,
        body: data,
        type: 'add',
      }),
    );
  };
  const createVCardPlusPhone = (data) => {
    dispatch(
      updateVCardPhoneThunk({
        id: data.microsite,
        body: data,
        type: 'add',
      }),
    );
  };
  const createVCardPlusWebsite = (data) => {
    dispatch(
      updateVCardWebsiteThunk({
        id: data.microsite,
        body: data,
        type: 'add',
      }),
    );
  };
  const deleteVCardPlusEmail = (emailId) => {
    dispatch(
      updateVCardEmailThunk({
        id: micrositeData?.id,
        body: emailId,
        type: 'delete',
      }),
    );
  };
  const deleteVCardPlusPhone = (phoneId) => {
    dispatch(
      updateVCardPhoneThunk({
        id: micrositeData?.id,
        body: phoneId,
        type: 'delete',
      }),
    );
  };
  const deleteVCardPlusWebsite = (websiteId) => {
    dispatch(
      updateVCardWebsiteThunk({
        id: micrositeData?.id,
        body: websiteId,
        type: 'delete',
      }),
    );
  };
  const updateVCardPlusEmail = ({ emailId, body }) => {
    dispatch(
      updateVCardEmailThunk({
        id: micrositeData?.id,
        body: {
          id: emailId,
          data: body,
        },
        type: 'update',
      }),
    );
  };
  const updateVCardPlusPhone = ({ phoneId, body }) => {
    dispatch(
      updateVCardPhoneThunk({
        id: micrositeData?.id,
        body: {
          id: phoneId,
          data: body,
        },
        type: 'update',
      }),
    );
  };
  const updateVCardPlusWebsite = ({ websiteId, body }) => {
    dispatch(
      updateVCardWebsiteThunk({
        id: micrositeData?.id,
        body: {
          id: websiteId,
          data: body,
        },
        type: 'update',
      }),
    );
  };

  const updateVCardPlusPersonData = (body) => {
    dispatch(
      updateVCardPlusPersonThunk({
        id: micrositeData.id,
        body,
      }),
    );
  };

  return (
    <CreateQRContentBlockLayout type="basicInfo">
      <Accordion
        variant="child"
        defaultExpanded
        summary={t('template5:about')}
        details={
          <>
            {micrositeData && (
              <VCardPlusAboutYou
                updateVCardPlusPersonData={updateVCardPlusPersonData}
                vCardPlusData={micrositeData}
                updateVCardPlusData={updateVCardPlusData}
                isBuilder
                showCoverImage={selectedTemplate === 1}
              />
            )}
          </>
        }
      />
      {micrositeData?.phones && (
        <VCardContactInfo
          updateVCardPlusData={updateVCardPlusData}
          createVCardPlusEmail={createVCardPlusEmail}
          createVCardPlusPhone={createVCardPlusPhone}
          createVCardPlusWebsite={createVCardPlusWebsite}
          vCardPlusData={micrositeData}
          deleteVCardPlusEmail={deleteVCardPlusEmail}
          deleteVCardPlusPhone={deleteVCardPlusPhone}
          deleteVCardPlusWebsite={deleteVCardPlusWebsite}
          updateVCardPlusEmail={updateVCardPlusEmail}
          updateVCardPlusPhone={updateVCardPlusPhone}
          updateVCardPlusWebsite={updateVCardPlusWebsite}
        />
      )}
      {micrositeData?.location && (
        <VCardPlusLocation vCardPlusData={micrositeData} updateVCardPlusLocation={updateVCardPlusLocation} />
      )}
      <VCardPlusSummary defaultValue={summary} updateVCardPlusData={updateVCardPlusData} hideAccordionBottomBorder />
    </CreateQRContentBlockLayout>
  );
}
